<template>
  <div>
    <div id="search"></div>
    <div v-if="show" id="loading">
      <img src="@/assets/loading_mzcr.webp" width="75" alt="Logo" />
    </div>
  </div>
</template>

<script>
import { loadModules } from "esri-loader";
import { bus } from "../main";
import * as moment from "moment";
import { GEO_SERVICES_BASE_URL } from "../env";

export default {
  name: "web-map",
  data() {
    return {
      map: null,
      featureLayer: null,
      sessionsFeatureLayer: null,
      featureLayerView: null,
      basicLayer: null,
      show: true,
      topoLayer: null,
      ortofotoLayer: null
    };
  },
  created() {
    this.$root.$refs.webMap = this;
  },
  mounted() {
    loadModules(
      [
        "esri/Map",
        "esri/views/MapView",
        "esri/layers/FeatureLayer",
        "esri/layers/TileLayer",
        "esri/widgets/Search"
      ],
      { css: true }
    ).then(([ArcGISMap, MapView, FeatureLayer, TileLayer, Search]) => {
      const layerUrl = `${GEO_SERVICES_BASE_URL}/LetniTabory_View/MapServer/0`;
      this.basicLayer = new TileLayer({
        url: "https://ags.cuzk.cz/arcgis1/rest/services/ZTM/MapServer"
      });

      this.ortofotoLayer = new TileLayer({
        url: "https://ags.cuzk.cz/arcgis1/rest/services/ORTOFOTO/MapServer"
      });

      this.map = new ArcGISMap({
        layers: [this.basicLayer]
      });

      const renderer = {
        type: "unique-value",
        field: "type",
        defaultSymbol: {
          type: "picture-marker",
          url: require("@/assets/neznama.svg"),
          width: "35px",
          height: "35px"
        },
        uniqueValueInfos: [
          {
            value: "campCurrentSeason",
            symbol: {
              type: "picture-marker",
              url: require("@/assets/zotavovaci-letos.png"),
              width: "35px",
              height: "35px"
            }
          },
          {
            value: "campLastSeason",
            symbol: {
              type: "picture-marker",
              url: require("@/assets/zotavovaci-loni.png"),
              width: "35px",
              height: "35px"
            }
          },
          {
            value: "otherEventCurrentSeason",
            symbol: {
              type: "picture-marker",
              url: require("@/assets/jine-letos.png"),
              width: "35px",
              height: "35px"
            }
          },
          {
            value: "otherEventLastSeason",
            symbol: {
              type: "picture-marker",
              url: require("@/assets/jine-loni.png"),
              width: "35px",
              height: "35px"
            }
          }
        ]
      };

      this.featureLayer = new FeatureLayer({
        url: layerUrl,
        renderer: renderer,
        outFields: ["*"]
      });
      this.map.add(this.featureLayer);

      this.view = new MapView({
        container: this.$el,
        map: this.map,
        center: [16, 49.5],
        zoom: 1,
        highlightOptions: {
          color: "006622"
        }
      });

      this.view.constraints = {
        maxScale: 11500
      };

      this.view.whenLayerView(this.featureLayer).then(layerView => {
        this.featureLayerView = layerView;
        this.featureLayerView.watch("updating", evt => {
          if (evt === false) {
            this.show = false;
          }
        });
      });

      // Add the result to the bottom-right corner of the view

      const searchWidget = new Search({
        container: "search",
        view: this.view,
        popupEnabled: false
      });

      this.view.ui.add(searchWidget, "manual");

      this.view.when(() => {
        this.view.on("click", this.onClickHandler);
        this.view.on("pointer-move", this.onPointerMoveHandler);
      });
    });
  },
  methods: {
    onClickHandler(event) {
      const screenPoint = { x: event.x, y: event.y };

      this.view.hitTest(screenPoint).then(response => {
        if (response.results.length > 0) {
          const graphic = response.results[0].graphic;

          if (this.highlightSelect) {
            this.highlightSelect.remove();
          }

          this.highlightSelect = this.featureLayerView.highlight(graphic);

          const id = graphic.attributes.OBJECTID;

          if (id != null) {
            const relationshipQuery = {
              outFields: ["*"],
              relationshipId: 0,
              returnGeometry: false,
              objectIds: id
            };

            this.featureLayer
              .queryRelatedFeatures(relationshipQuery)
              .then(result => {
                const sessions =
                  result[id]?.features?.map(f => f.attributes) ?? [];

                sessions.sort((a, b) => {
                  try {
                    return moment(a.dateFrom, "DD.MM.YYYY").isAfter(
                      moment(b.dateFrom, "DD.MM.YYYY")
                    )
                      ? 1
                      : -1;
                  } catch (e) {
                    return -1;
                  }
                });

                bus.$emit("detailChanged", true, graphic.attributes, sessions);
              });
          }
        }
      });
    },
    onPointerMoveHandler(event) {
      const screenPoint = { x: event.x, y: event.y };
      this.view.hitTest(screenPoint).then(response => {
        this.changeCursor(response);
      });
    },
    changeData: function(zotavovaci, jina) {
      let sqlExpressions = "";
      if (zotavovaci && jina) {
        sqlExpressions = "type LIKE 'other%' OR type LIKE 'camp%'";
      } else if (zotavovaci && !jina) {
        sqlExpressions =
          "type = 'campCurrentSeason' OR type = 'campLastSeason'";
      } else if (!zotavovaci && jina) {
        sqlExpressions =
          "type = 'otherEventCurrentSeason' OR type = 'otherEventLastSeason'";
      } else {
        sqlExpressions = "type = 'null'";
      }
      this.view.whenLayerView(this.featureLayer).then(featureLayerView => {
        featureLayerView.filter = {
          where: sqlExpressions
        };
      });
    },
    changeCursor: function(response) {
      if (response.results.length > 0) {
        this.view.cursor = "pointer";
      } else {
        this.view.cursor = "default";
      }
    },
    changeBaseMap: function(bm) {
      switch (bm) {
        case "ortofoto":
          this.map.remove(this.basicLayer);
          this.map.remove(this.topoLayer);
          this.map.add(this.ortofotoLayer, 0);
          break;
        default:
          this.map.remove(this.ortofotoLayer);
          this.map.remove(this.topoLayer);
          this.map.add(this.basicLayer, 0);
      }
    }
  },
  beforeDestroy() {
    if (this.view) {
      this.view.container = null;
    }
  }
};
</script>

<style scoped>
div {
  position: relative;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

#search {
  position: absolute;
  top: 15px;
  left: 75px;
  width: 250px;
  height: 35px;
  -webkit-box-shadow: 0px 0px 0px 1px rgba(222, 222, 222, 1);
  -moz-box-shadow: 0px 0px 0px 1px rgba(222, 222, 222, 1);
  box-shadow: 0px 0px 0px 1px rgba(222, 222, 222, 1);
}

#loading {
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #006622;
  color: white;
  padding: 5px;
  width: 75px;
  height: 15px;
  z-index: 20;
  -webkit-box-shadow: 0px 0px 0px 1px rgba(222, 222, 222, 1);
  -moz-box-shadow: 0px 0px 0px 1px rgba(222, 222, 222, 1);
  box-shadow: 0px 0px 0px 1px rgba(222, 222, 222, 1);
}
</style>
